export default __webpack_public_path__ + "static/media/correspondent23.99e80677.png";